
import { CommonModule } from "@angular/common";
import { Component,ChangeDetectorRef, OnDestroy, importProvidersFrom, signal, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { Subscription } from "rxjs";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TemplateService } from "./n-template.service";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { CompanyAttributes, NotificationTemplateAttributes } from "@albatrosdeveloper/ave-models-package";
import { MatMenuModule } from "@angular/material/menu";
import { MatSlideToggle, MatSlideToggleModule } from "@angular/material/slide-toggle";
import { NotificationEventEnum, NotificationTemplateStatusEnum, NotificationTypesEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TextFieldModule } from "@angular/cdk/text-field";
import { QuillEditorComponent } from 'ngx-quill';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { CompanyService } from "../../configuration/company/company.service.service";
import { DistributionChainService } from "../../configuration/distribution-chain/distribution-chain.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import { MatBadgeModule } from "@angular/material/badge";
import { MatTabsModule } from "@angular/material/tabs";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { NotificationsFiltersComponent } from "../../filters/notifications-filters/notifications-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { ICreateNotificationTemplate } from "./interfaces/templace-interface";
import { getCode } from "app/utils/method";
import { SharedStateService } from "../shared/shared-state.service";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: 'app-n-template',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatInputModule,
    MatOptionModule,
    MatSlideToggleModule,
    TextFieldModule,
    QuillEditorComponent,
    MatSelectModule,
    MatOptionModule,
    MatSlideToggle,
    MatTabsModule,
    MatBadgeModule,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './n-template.component.html',
})
export class NTemplateComponent {
  getCode = getCode

  notificationTypesEnum = NotificationTypesEnum
  companyFilterList: CompanyAttributes[] = []
  notificationTemplateStatusEnum = NotificationTemplateStatusEnum
  notificationEventEnum = NotificationTypesEnum
  companyList: CompanyAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = '';
  isLoadingSalesOffices = false; // Para mostrar loading


  displayedColumns: string[] = [
    "typeId",
    "statusId",
    "name",
    "subject",
    "company",
    "salesOffice",
    "action"
  ];
  dataSource = new MatTableDataSource<any>([]);

  //#region Filter
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof any = "name";
  sortDirection: "ASC" | "DESC" = "ASC";
  //#endregion

  //#region Form
  public id: any = null
  currentTemplate: ICreateNotificationTemplate = this.initializeTemplate();

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  form: FormGroup;

  listChannel: number[] = Object.values(NotificationTypesEnum).filter((value): value is number => typeof value === 'number');
  listStatus: number[] = Object.values(NotificationTemplateStatusEnum).filter((value): value is number => typeof value == 'number');
  listEvents: number[] = Object.values(NotificationEventEnum).filter((value): value is number => typeof value === 'number');
  quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [], 
      [{ 'header': 1 }, { 'header': 2 }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [], 
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['clean'],
      ['link', 'image']
    ]
  };
  //#endregion

  searchSubscription: Subscription;

  constructor(
    private templateService: TemplateService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly companyService: CompanyService, 
    private readonly salesOfficeService: SalesOfficeService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private sharedStateService: SharedStateService,

  ) { 
    this.form = this.fb.group({
      companyId: [],
      distributionChainId: [],
      salesOfficeId: [],      
      notificationMemberId: [],
      statusId: [null],
    })
  }

  ngAfterViewInit(): void {
    this.onHandleSearch()
    this.getList();
    this.getAllCompanies();
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  getList() {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    this.templateService.getAllPaginate(options).subscribe({
      next: (res: IPaginationResult<NotificationTemplateAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupos","Cerrar",{ duration: 5000});
      },
    })
  }
  
  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  //#region Form
  private initializeTemplate(): ICreateNotificationTemplate {
    return {
      name: null,
      subject: null,
      isBodyHtml: true,
      bodyHtml: '',
      bodyText: null,
      typeId: NotificationTypesEnum.EMAIL,
      statusId: null,
      eventId: null,
      companyId: null,
      salesOfficeId: null,
    };
  }

  getListTypeLabel(type: number): string {
    const labels = {
      [NotificationTypesEnum.EMAIL]: 'Email',
      [NotificationTypesEnum.WHATSAPP]: 'Whatsapp',
      [NotificationTypesEnum.NOTIFICATIONS]: 'Notificaciones',
    };
    return labels[type] || type;
  }

  getListStatusLabel(status: number): string {
    const labels = {
      [NotificationTemplateStatusEnum.ACTIVE]: 'Activo',
      [NotificationTemplateStatusEnum.DRAFT]: 'Borrador',
      [NotificationTemplateStatusEnum.ARCHIVED]: 'Archivado',
    };
    return labels[status] || status;
  }
  
  getListEventLabel(eventId: number): string {
    const labels = {
      [NotificationEventEnum.NUMERATION_RANGE_EXPIRING]: 'Rango de numeración próximo a vencer',
      [NotificationEventEnum.NUMERATION_RANGE_RUNNING_OUT]: 'Rango de numeración próximo a agotarse.',
      [NotificationEventEnum.PRODUCT_CHANGE_REQUEST_PENDING]: 'Solicitud de cambio de producto pendiente de aprobar',
      [NotificationEventEnum.PRODUCT_CHANGE_PENDING]: 'Cambio de producto pendiente de aprobar',
      [NotificationEventEnum.PRODUCT_RETURN_REQUEST_PENDING]: 'Solicitud de devolución de producto pendiente de aprobar',
      [NotificationEventEnum.PRODUCT_RETURN_PENDING]: 'Devolución de producto pendiente de aprobar',
      [NotificationEventEnum.CUSTOMER_PENDING_APPROVAL]: 'Cliente nuevo pendiente por aprobar',
      [NotificationEventEnum.QUOTATION_PENDING_APPROVAL]: 'Cotización pendiente por aprobar',
      [NotificationEventEnum.QUOTATION_APPROVED]: 'Cotización aprobada',
      [NotificationEventEnum.QUOTATION_REJECTED]: 'Cotización rechazada',
      [NotificationEventEnum.USERS_ORDERS_SUMMARY]: 'Resumen de usuarios del día',
      [NotificationEventEnum.USER_ORDERS_INDIVIDUAL]: 'Resumen del usuario individual',
      [NotificationEventEnum.ORDER_DELIVERED]: 'Orden entregada',
      [NotificationEventEnum.ORDER_FINALIZED]: 'Orden finalizada',
      [NotificationEventEnum.ORDER_CREATED]: 'Nueva orden creada',
      [NotificationEventEnum.BP_DESACTIVATION_REQUEST_CREATED]:
        'Solicitud de inactivacion de clientes',
      [NotificationEventEnum.BP_DESACTIVATION_REQUEST_APPROVED]:
        'Aprobación de solicitud de inactivacion de clientes',
      [NotificationEventEnum.BP_DESACTIVATION_REQUEST_DECLINE]:
        'Rechazo de solicitud de inactivacion de clientes',
      [NotificationEventEnum.INTEGRATION_ERROR]: 'Error de integración',
      [NotificationEventEnum.INTEGRATION_MASTER_ERROR]:
        'Error de integración de maestros',
      [NotificationEventEnum.BP_FIELD_EDIT_REQUEST_PENDING]:
        'Solicitud de edición de campo de cliente pendiente de aprobar',
      [NotificationEventEnum.BP_ADDRESS_EDIT_REQUEST_PENDING]:
        'Solicitud de edición de dirección de cliente pendiente de aprobar',
      [NotificationEventEnum.BP_EDIT_REQUESTS_BULK_INSERTED]:
        'Solicitud de edición de cliente masiva insertada',
      [NotificationEventEnum.BP_EDIT_REQUEST_APPROVED]:
        'Solicitud de edición de campo de cliente aprobada',
      [NotificationEventEnum.BP_EDIT_REQUEST_REJECTED]:
        'Solicitud de edición de campo de cliente rechazada',
      [NotificationEventEnum.PRODUCT_CHANGE_REQUEST_APPROVED]: 'Solicitud de cambio de producto aprobada',
      [NotificationEventEnum.PRODUCT_CHANGE_REQUEST_REJECTED]: 'Solicitud de cambio de producto rechazada',
      [NotificationEventEnum.PRODUCT_RETURN_REQUEST_APPROVED]: 'Solicitud de devolución de producto aprobada',
      [NotificationEventEnum.PRODUCT_RETURN_REQUEST_REJECTED]: 'Solicitud de devolución de producto rechazada',
      [NotificationEventEnum.USER_CREATED]: 'Usuario creado',
      [NotificationEventEnum.USER_PASSWORD_CHANGED]: 'Cambio de contraseña de usuario',
      [NotificationEventEnum.BP_PROSPECT_APPROVED]: 'Aprobación de cliente prospecto',
      [NotificationEventEnum.BP_PROSPECT_REJECTED]: 'Rechazo de cliente prospecto',
      [NotificationEventEnum.CREDIT_APPLICATION_PENDING]: 'Solicitud de crédito pendiente',
      [NotificationEventEnum.CREDIT_APPLICATION_APPROVED]: 'Aprobación de solicitud de crédito',
      [NotificationEventEnum.CREDIT_APPLICATION_REJECTED]: 'Rechazo de solicitud de crédito',
      [NotificationEventEnum.ORDER_APPROVED]: 'Pedido aprobado',
      [NotificationEventEnum.ORDER_REJECTED]: 'Pedido rechazado',
      [NotificationEventEnum.LOAN_REQUEST_APPROVED]: 'Solicitud de préstamo de embalaje aprobada',
      [NotificationEventEnum.LOAN_REQUEST_REJECTED]: 'Solicitud de préstamo de embalaje rechazada',
      [NotificationEventEnum.PACK_LOAN_REQUEST_CREATED]: 'Solicitud de préstamo de embalaje creada',
      [NotificationEventEnum.TRIP_AUTOMATIC_CREATION_FAILED]:
        'Falla en la creación automática de viajes',
    };
    return labels[Number(eventId)] || 'Evento ' + eventId;
  }
  



  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data || [];
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open('Error al cargar las compañías', 'Cerrar', { duration: 3000 });
      }
    });
  }

 
  getAllSalesOfficeList(companyId: string): void {
    if (!companyId) {
      return;
    }

    this.isLoadingSalesOffices = true;
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data || [];
        this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
        this.isLoadingSalesOffices = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.salesOfficeList = [];
        this.listFilterSalesOfficeList.update(() => []);
        this.isLoadingSalesOffices = false;
        this.snackBar.open('Error al cargar oficinas de ventas', 'Cerrar', { duration: 3000 });
        this.cdr.detectChanges();
      }
    });
  }

  onContentChanged(event: any) {
    this.currentTemplate.bodyHtml = event.html;
  }
  
  changueOptionsSalesOffice(event: string): void {
    if (!this.salesOfficeList || this.salesOfficeList.length === 0) {
      return;
    }
    
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    
    this.listFilterSalesOfficeList.update(() => 
      this.salesOfficeList.filter(item => 
        item.externalKeys?.code?.toLowerCase().indexOf(search) > -1 || 
        item.name?.toLowerCase().indexOf(search) > -1
      )
    );
  }


  private stripHtmlTags(html: string): string {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    let textContent = tempDiv.textContent || tempDiv.innerText || '';
  return textContent.replace(/\s+/g, ' ').trim();
}




onQuillContentChanged(event: any) {
  this.currentTemplate.bodyHtml = event.html;
  if (this.currentTemplate.isBodyHtml) {
    this.currentTemplate.bodyText = this.stripHtmlTags(event.html);
  }
}


  onCompanySelectionChange(companyId: string): void {
    this.currentTemplate.salesOfficeId = null;
    this.searchOffice = '';
    
    if (companyId && companyId !== '') {
      this.salesOfficeList = [];
      this.listFilterSalesOfficeList.update(() => []);
      this.getAllSalesOfficeList(companyId);
    } else {
      this.salesOfficeList = [];
      this.listFilterSalesOfficeList.update(() => []);
    }
  }
 
  openModal(template?: any): void {
    if (this.companyList.length === 0) {
      this.getAllCompanies();
    }
    
    if (template) {
      // Modo edición
      this.currentTemplate = {
        ...template,
        code: template.code,
        externalKey: this.getCode(template) ? this.getCode(template) : null,
        companyId: template.company ? template.company._id.toString() : null,
        salesOfficeId: template.salesOffice ? template.salesOffice._id.toString() : null,
        statusId: template.statusId != null ? Number(template.statusId) : null
      };

      this.id = template._id;

      if (this.currentTemplate.companyId) {
        this.getAllSalesOfficeList(this.currentTemplate.companyId);
      }
    } else {
      this.currentTemplate = this.initializeTemplate();
      this.id = null;
      this.salesOfficeList = [];
      this.listFilterSalesOfficeList.update(() => []);
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '65%', disableClose: true });
    this.dialogRef.afterClosed().subscribe((result) => { 
    });
  }

  onSubmit(){
    if(this.id == null){
      this.createTempleate()
    }else{
      this.updateTemplate(this.id)
    }
  }

  createTempleate(): void {
    const dataToSend:any = Object.entries(this.currentTemplate)
      .reduce((acc, [key, value]) => {
        if (value !== '' && value !== null) { 
          acc[key] = value;
        }
        return acc;
      }, {});

      if (this.currentTemplate.isBodyHtml && this.currentTemplate.bodyHtml && !this.currentTemplate.bodyText) {
        this.currentTemplate.bodyText = this.stripHtmlTags(this.currentTemplate.bodyHtml);
      }
      
      if (!this.currentTemplate.isBodyHtml) {
          this.currentTemplate.bodyHtml = '';
      }

    this.templateService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
        this.sharedStateService.notifyTemplatesUpdated(); // Notificar cambio
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateTemplate(id: string): void {
    if (this.currentTemplate) {
      const updatedTemplate: any = {
        ...this.currentTemplate,
      };


      this.templateService.update(id, updatedTemplate).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if (this.dialogRef) {
            this.dialogRef.close(true);

          }
          this.getList();
          this.sharedStateService.notifyTemplatesUpdated(); // Notificar cambio
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  openDeleteDialog(groupN: any): void {
    this.dialog
      .open(this.deleteDialog, { data: groupN, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(groupN._id.toString()));
  }

  delete(id: string): void {
    this.templateService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
      this.sharedStateService.notifyTemplatesUpdated(); // Notificar cambio
    });
  }
  
}